<template>
    <div class="network-error-layer">
        <h4>კავშირის პრობლემა</h4>
        <loading color="#5B4343"/>
        <h6>დაკავშირების მცდელობა ({{currentConnectionAttempt}})</h6>
    </div>
</template>

<script>
    import Loading from "./Loading";
    export default {
        props:['currentConnectionAttempt'],
        components:{
            Loading
        }
    }
</script>

<style scoped>
    .network-error-layer {
        position: absolute;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        background-color: rgba(255, 255, 255, 0.6);
        color: #333;
        z-index: 9999;
    }

    .network-error-layer h4 {
        font-size: 1.5rem;
        margin-bottom: 20px;
    }

    .network-error-layer h6 {
        font-size: .85rem;
        margin-top: 20px;
    }
</style>